import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Vue from 'vue';
import BravadoLogoIcon from './images/bravado-logo.vue.svg';
var OFFICIAL_SLUG = 'official';
export default Vue.extend({
  name: 'WarRoomTopic',
  components: {
    BravadoLogoIcon: BravadoLogoIcon
  },
  props: {
    isElevated: {
      type: Boolean,
      default: false
    },
    isLink: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    topic: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    isOfficial: function isOfficial() {
      return this.topic.slug === OFFICIAL_SLUG;
    },
    rootClass: function rootClass() {
      return _defineProperty(_defineProperty(_defineProperty({
        'war-room-topic': true
      }, "war-room-topic--".concat(this.size), true), 'war-room-topic--elevated', this.isElevated), 'war-room-topic--active', this.isActive);
    }
  },
  render: function render(h) {
    var rootElement = this.isLink ? 'NuxtLink' : 'span';
    var rootProps = _objectSpread({}, this.$attrs);
    var rootChildren = [];
    if (this.isLink) {
      Object.assign(rootProps, {
        to: {
          name: 'war-room-topics-topicSlug-posts',
          params: {
            topicSlug: this.topic.slug
          }
        }
      });
    }
    if (this.isOfficial) {
      rootChildren.push(h(BravadoLogoIcon, {
        class: 'war-room-topic__icon'
      }));
    }
    rootChildren.push(h('div', {
      class: 'war-room-topic__name'
    }, "".concat(this.topic.emoji, " ").concat(this.topic.name)));
    var rootData = {
      props: rootProps,
      class: this.rootClass
    };
    if (!this.isLink) {
      Object.assign(rootData, {
        on: _objectSpread({}, this.$listeners)
      });
    }
    return h(rootElement, rootData, rootChildren);
  }
});